{
  "organizations": {
    "navigation_title": "Organizaciones",
    "all": "Todas las organizaciones",
    "filter_input": "Filtrar organizaciones...",
    "partners_filter_input": "Filtrar asociaciones...",
    "invitations_filter_input": "Filtrar invitaciones...",
    "formation_requests_filter_input": "Filtrar solicitudes de la organización...",
    "title": "Organizaciones",
    "list_title": "Organizaciones",
    "new": "Crear Organización",
    "edit": "Editar Organización",
    "form_title": "Organización",
    "create_new": "Nueva organización",
    "rental": "Renta",
    "past_due_warned": "Vencido",
    "save": "Guardar",
    "go_to_index": "Regresar a las organizaciones",
    "select_industry": "Seleccionar sector...",
    "more_info": {
      "contact_info": "Contacto",
      "office": "Oficina",
      "address": "Dirección"
    },
    "send_formation_request": "Solicitud de la organización",
    "edit_details": "Editar organización",
    "logo": "Marca",
    "requests": "Solicitudes",
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar la organización \"%{name}\"? No puede deshacer esta acción"
      }
    }
  }
}
